import { NavListItem, NavListItemProps, Space } from '@billy/design-system'

export const LogoutListItem = (props: NavListItemProps<string>) => (
  <>
    <Space size="s12" />
    <NavListItem {...props} />
  </>
)
